import { Extension } from '@codemirror/state'
import { EditorView } from '@codemirror/view'

export const grammarly = (): Extension => {
  return EditorView.updateListener.of(viewUpdate => {
    viewUpdate.view.dom.dataset['grammarlyText'] = viewUpdate.state.doc.toString()
  })
}
